import { getStorageItem, updateStorageItem } from 'utils/browserCache';
import { config } from 'utils/handRaiser/config';
import { LOCAL_STORAGE_KEY, STORAGE_LOCATION } from 'constants/browserCache';
import { ChatHandRaiserType, HandRaiserCacheDataType } from './types';

export const getHandRaiserConfig = (pathname: string) => {
  const matchedConfigKey = Object.keys(config.handraisers).find((hrc) => {
    if (config.handraisers[hrc].regexMatch) {
      return RegExp(hrc).test(pathname);
    }
    return hrc === pathname;
  });

  if (!matchedConfigKey) return { matchedConfigKey, matchedConfig: undefined };

  return { matchedConfigKey, matchedConfig: config.handraisers[matchedConfigKey] };
};

export const shouldTriggerHandRaiser = (
  pathname: string,
  handRaiserItemConfig?: ChatHandRaiserType,
): boolean => {
  const { matchedConfigKey } = getHandRaiserConfig(pathname);
  if (!handRaiserItemConfig || !handRaiserItemConfig.enabled || !matchedConfigKey) {
    return false;
  }

  const cachedHandRaiserData = getStorageItem(
    STORAGE_LOCATION.LOCAL_STORAGE,
    LOCAL_STORAGE_KEY.CHAT_HANDRAISERS,
  ) as HandRaiserCacheDataType;

  const cachedHandRaiserItem = cachedHandRaiserData?.[matchedConfigKey];
  if (!cachedHandRaiserItem) {
    return true;
  } else if (cachedHandRaiserItem.shown) {
    const isExpired = cachedHandRaiserItem.expires > Date.now();
    return !isExpired;
  }
  return false;
};

export const updateHandRaiserStorage = (
  pathname: string,
  elapsedExpiry: number | null = config.defaultElapsedExpiry,
): void => {
  const cachedHandRaiserData = getStorageItem(
    STORAGE_LOCATION.LOCAL_STORAGE,
    LOCAL_STORAGE_KEY.CHAT_HANDRAISERS,
  ) as HandRaiserCacheDataType;

  const cachedHandRaiserItem = cachedHandRaiserData?.[pathname];

  if (cachedHandRaiserItem && cachedHandRaiserData.elapsedExpiry === null) return;

  if (!cachedHandRaiserItem || Date.now() > cachedHandRaiserItem.expires) {
    updateStorageItem(STORAGE_LOCATION.LOCAL_STORAGE, LOCAL_STORAGE_KEY.CHAT_HANDRAISERS, {
      ...cachedHandRaiserData,
      [pathname]: {
        shown: Date.now(),
        expires: elapsedExpiry === null ? null : Date.now() + elapsedExpiry,
      },
    });
  }
};
